export { documents } from "./investors";
export type { Document, AnnualDocuments } from "./investors";
